import http from '@/utils/http'
import Utils from '@/utils/default'

const fetchAll = ({ page = 1 }) => http()
  .get(`/outcomes?${Utils.dataToUrlString({ page })}`)

export default {
  fetchAll
}



// WEBPACK FOOTER //
// ./src/api/outcome.js